(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('CloudPBXPrefix', CloudPBXPrefix);

    CloudPBXPrefix.$inject = ['$resource'];

    function CloudPBXPrefix ($resource) {
        var resourceUrl =  'api/cloud-pbx-prefixes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
